/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.03.2016
 * Copyright: xdot GmbH 2015
 */

import ClassRemoteDataStore from './ClassRemoteDataStore';
import RemoteDataStore, { isList } from './RemoteDataStore';
import warning from '../utils/warning';
import shallowEqual from '../utils/shallowEqual';

const equalSeries = (s1, s2) => s1.metric === s2.metric && shallowEqual(s1.labels, s2.labels);


function checkDistinctOrder(a) {
    if (!a.every((c, i) => {
            const e = i === 0 || a[ i - 1 ] < c;
            if (!e) {
                console.error('checkDistinctOrder no element in a');
            }
            return e;

        })) {
        console.error('Invalid timestamps');
    }
}

export default class TimeSeriesRemoteDataStore extends ClassRemoteDataStore {

    initItem() {
        throw new Error('Only List data supported');
    }

    asyncSuccess(data, update) {
        warning(isList(data), 'Only List data supported');

        if (!update.changesSince) {
            //first data
            data = RemoteDataStore.updateList(data, update);
        } else {
            data = this.updateMetrics(data, update);
        }

        //TODO: Fix with deep copy ?
        // data._requestTime = update._requestTime; //remember the request time for updates
        data.query = {
            ...data.query,
            changesSince: update._requestTime
        };
        //data._invalid = true;
        return data;
    }

    updateMetrics(existing, update) {
        const newData = {
            ...existing,
            _loading: false,
            _invalid: false,
            _backup: null
        };

        if (update.item.findIndex(series => series.times.length > 0) < 0) {
            console.info('Empty timeseries update', update);
            return newData;
        }

        newData.item = existing.item.slice();

        update.item.forEach(m => {
            const idx = newData.item.findIndex(em => equalSeries(m, em));
            if (idx >= 0) {
                if (__DEV__) {
                    const temp = this.updateMetric(newData.item[ idx ], m);
                    checkDistinctOrder(temp.times);
                }

                newData.item[ idx ] = this.updateMetric(newData.item[ idx ], m);
            } else {
                console.warn('New series', m);
                newData.item.push(m);
                newData._count++;
                newData._end++;
                update._requestTime = null; //i think in this situation we should update all data to get the full new data
            }
        });

        return newData;
    }

    updateMetric(series, update) {
        if (update.times.length > 0) {

            if (update.times[ 0 ] > series.times[ series.times.length - 1 ]) {

                series = {
                    ...series,
                    meta: update.meta,
                    times: series.times.concat(update.times),
                    values: series.values.concat(update.values)
                };

            } else {
                series = this._multiUpdate(series, update);
            }
        }
        return series;
    }

    _multiUpdate(series, update) {
        const utimes = update.times, otimes = series.times,
            uvalues = update.values, ovalues = series.values;
        let ntimes = [],
            nvalues = [],
            ut = utimes[ 0 ], ot = otimes[ 0 ], unchanged = 0, ni = 0;

        // ntimes.length = nvalues.length = utimes.length + otimes.length;

        for (let ui = 0, oi = 0; ui < utimes.length || oi < otimes.length; ni++) {
            if (ut < ot) {
                ntimes[ ni ] = ut;
                nvalues[ ni ] = uvalues[ ui ];
                ui++;
                ut = ui < utimes.length ? utimes[ ui ] : Number.MAX_VALUE;
            } else if (ut > ot) {
                ntimes[ ni ] = ot;
                nvalues[ ni ] = ovalues[ oi ];
                oi++;
                ot = oi < otimes.length ? otimes[ oi ] : Number.MAX_VALUE;
            } else {
                ntimes[ ni ] = ut;
                nvalues[ ni ] = uvalues[ ui ];
                ui++;
                oi++;
                unchanged++;
            }
        }

        warning(ni === ntimes.length && ni === (utimes.length + otimes.length - unchanged), 'Unexpected update state!');

        if (unchanged === utimes.length) {
            if (shallowEqual(series.meta, update.meta)) {
                console.warn('Unchanged series update from ', series, 'to', update);
                return series;
            } else {
                ntimes = otimes;
                nvalues = ovalues;
            }
        }

        return {
            ...series,
            meta: update.meta,
            times: ntimes,
            values: nvalues
        };
    }


}



// WEBPACK FOOTER //
// ./js/stores/TimeSeriesRemoteDataStore.js